import { Notice, NoticeProps } from '@applyboard/crystal-ui'
import { DecisionResponseType, DocumentType } from '@applyboard/school-applications-types-lib'

type ApplicationDetailCardHelperProps = Readonly<{
  decisionDocumentTag: DocumentType
  status?: DecisionResponseType
  isRevoked?: boolean
  activeRecord: boolean
}>

function getHelperText(
  documentTag: DocumentType,
  status: DecisionResponseType | undefined,
  activeRecord: boolean,
  isRevoked?: boolean,
):
  | {
      label: NoticeProps['children']
      intent: NoticeProps['intent']
    }
  | undefined {
  switch (true) {
    case isRevoked:
      return {
        label: 'This offer was revoked and can no longer be verified by third parties.',
        intent: 'secondary',
      }
    case documentTag === DocumentType.DECLINED_LETTER:
      return {
        label:
          'We regret to inform you that, after careful consideration of your application, the school has decided to decline your offer.',
        intent: 'negative',
      }
    case documentTag === DocumentType.WAITLIST_LETTER:
      return {
        label: 'Please download the attached letter and review.',
        intent: 'warning',
      }
    case documentTag === DocumentType.PRE_OFFER_LETTER &&
      status === DecisionResponseType.REJECTED &&
      activeRecord:
      return {
        label: 'A decision has been made by you to reject the pre-offer letter.',
        intent: 'negative',
      }
    case documentTag === DocumentType.PRE_OFFER_LETTER &&
      (!status || status === DecisionResponseType.PENDING):
      return {
        label: 'Please download the attached pre-offer letter and review.',
        intent: 'secondary',
      }
    case documentTag === DocumentType.FINAL_OFFER_LETTER &&
      status === DecisionResponseType.ACCEPTED:
      return {
        label: 'Congratulations! You have received a final offer.',
        intent: 'positive',
      }

    default:
      return undefined
  }
}

export function ApplicationDetailCardHelper(props: ApplicationDetailCardHelperProps) {
  const helperText = getHelperText(
    props.decisionDocumentTag,
    props.status,
    props.activeRecord,
    props.isRevoked,
  )
  return helperText ? <Notice intent={helperText.intent}>{helperText.label}</Notice> : null
}
